import { useRef, type ReactNode } from "react";
import { createPortal } from "react-dom";
import "./competition.css";
import { useModalFocus } from "@/hooks/useModalFocus";
export function OfflineBanner() {
  return (
    <p className="competition-banner" role="status">
      Offline — changes unavailable.
    </p>
  );
}
export function LoadError({ error, retry }: { error: string; retry: () => void }) {
  return (
    <div className="card competition-error" role="alert">
      <h2>Could not load competition data</h2>
      <p>{error}</p>
      <button className="btn btn-primary" onClick={retry}>
        Retry
      </button>
    </div>
  );
}
export function Skeleton({
  labels = ["Competition", "Loading", "Loading"],
}: {
  labels?: string[];
}) {
  return (
    <div className="competition-stack" aria-label="Loading competition data" aria-busy="true">
      {labels.map((label, i) => (
        <div className="card competition-skeleton" key={i}>
          {label}
          <div />
        </div>
      ))}
    </div>
  );
}
export function SetupCard({
  title,
  children,
  expanded = false,
  id,
}: {
  title: string;
  children: ReactNode;
  expanded?: boolean;
  id: string;
}) {
  return (
    <details className="card setup-card" open={expanded} id={id}>
      <summary>{title}</summary>
      <div className="setup-card-body">{children}</div>
    </details>
  );
}
export function Dialog({
  title,
  children,
  onClose,
  className = "",
}: {
  title: string;
  children: ReactNode;
  onClose: () => void;
  className?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);
  useModalFocus(ref, true, onClose);
  return createPortal(
    <div
      className="competition-backdrop"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div
        ref={ref}
        className={`competition-dialog ${className}`}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        tabIndex={-1}
      >
        <h2>{title}</h2>
        {children}
      </div>
    </div>,
    document.body,
  );
}
